import { parseCurrencyType, type CurrencyType } from '@/lib/currency'
import { isAgent, type Role } from '@/data/types'

/**
 * Which Net Exposure book surface is being formatted.
 * Only `match` (Betfair) and `bookmaker` force Lab-style INR for POINTS agents.
 * Fancy / line-session / casino / card / crash / slots stay on viewer currency.
 */
export type NetExposureBookKind = 'match' | 'bookmaker' | 'fancy' | 'other'

/**
 * Lab workstation book tree always used `indianCurrency` / Rs (INR), even for
 * POINTS hierarchies. Strix was painting Pts from viewer currency.
 *
 * Rule: POINTS **agents** (TM→Master, not CM) show INR on Betfair + bookmaker
 * books only. CM unchanged. Fancy / line / casino / card / crash / slots keep Pts.
 */
export function netExposureDisplayCurrency(input: {
  viewerCurrency: string | CurrencyType
  viewerRole: Role
  bookKind: NetExposureBookKind
}): CurrencyType {
  const ccy = parseCurrencyType(input.viewerCurrency)
  if (input.viewerRole === 'company-master') return ccy
  if (
    isAgent(input.viewerRole) &&
    ccy === 'POINTS' &&
    (input.bookKind === 'match' || input.bookKind === 'bookmaker')
  ) {
    return 'INR'
  }
  return ccy
}

/** Map workstation / list market type onto the display gate. */
export function netExposureBookKindFromMarketType(
  type: string | undefined | null,
): NetExposureBookKind {
  if (type === 'match' || type === 'bookmaker' || type === 'fancy') return type
  return 'other'
}
